export default {
    menu:{
        home: '首页',
        about:'关于我们',
        partners: '合作伙伴',
        contact:'联络我们'
    },
    home:{
        aboutPPTitle:'关于尊尚礼遇计划',
        aboutPPIntro:'我们的尊尚礼遇计划为家庭带来无限乐趣和超值优惠！透过此计划，您可以使用Monkey Coin购买各种精彩产品和体验，以及日常必需品。让您的家庭时光更加难忘，同时也能帮您省钱！',
        aboutPPSmallText1:'Monkey Coin 充值简单、快捷。',
        aboutPPSmallText2:'为香港父母贴心设计的应用程式。',
        aboutPPSmallText3:'超过<span class="highlight-count">50间</span>本地亲子商户专属优惠，折扣与体验。',
        monkeyCoinTitle:'享受活动和产品的最佳折扣。',
        'monkeyCoin-Excursion':'游学团',
        'monkeyCoin-Fun':'童趣玩乐',
        'monkeyCoin-Premiums':'Monkey Tree<br>精选礼品',
        'monkeyCoin-Cash':'现金券',
        'monkeyCoin-Gift':'礼品兑换',
        'monkeyCoin-Complimentary' :'免费兑换',
        topUpCoinTitle:'充值Monkey Coin',
        topPicks:'首选优惠',
        'top-fun':'童趣玩乐',
        'top-fun-smallText':'价值HK$370',
        'top-excursion':'游学团',
        'top-excursion-20':'8',
        'top-excursion-endText':'折优惠',
        'top-cash':'现金券',
        learnMore:'了解更多',
        'member-Registration':'会员注册',
        'member-Registration-intro': '立即下载Monkey Tree App，注册成为会员，即可享有专属礼遇！',
        'video-Tutorial': '影片教学',
        'video-registration':'注册',
        registration1:'Monkey Tree App\n 注册 (学生)',
        registration2:'密码找回',
        registration3:'变更语言设定',
        'video-redemption':'兑换',
        redemption1:'充值Monkey Coin',
        redemption2:'现金券兑换',
        redemption3:'礼品兑换',
        redemption4:'免费兑换',
        redemption5:'娱乐兑换',
    },
    common:{
        bottomBarText:'立即注册，享受专属福利！',
        close:'关闭'
    },
    footer:{
        address:'香港太古城英皇道1111号25楼2514室',
        email:'信箱：enquiry@monkeytree.com.hk',
        tel:'电话：(852) 3563-6771',
        siteMap:'网站地图',
        connect:'社交媒体',
        copyRight:'◎ Monkey Tree App. 版权所有',
        privacy:'隐私权声明',
        termUse:'使用条款',
    },
    contact:{
        contactUs:'联络我们',
        text:'只需填写联络表格，我们将尽快与您联系！',
        name:'姓名:',
        email:'信箱:',
        message:'留言:',
        submit:'提交',
        tip1:'我们是本网站所收集资讯的唯一所有者。我们仅收集并存取您透过电子邮件或其他直接联络方式自愿提供的资讯。我们不会将此资讯出售或出租给任何人。',
        tip2:'我们将使用您的资讯回复您，解答您联络我们的原因。除满足您的请求所需的情况外，我们不会与本组织以外的任何第三方分享您的资讯。'
    },
    about:{
        contact:'联络方式',
        socialMedia:'社群媒体',
        down:'下载 Monkey Tree App',
        mt:'Monkey Tree App',
        mtp1:'下载Monkey Tree App，立刻开启专属家庭福利：赚取并储值Monkey Coins，换好礼、换体验；轻松预订精心策划的户外与亲子活动，陪孩子一起学习、玩乐、增进感情；还能领超值现金券和商家专属优惠，日常更省心省钱。',
        mtp2:"会员专属好康、简单的现金券兑换、安全付款与订单管理，一应俱全。用最方便的方式，把更多美好亲子时光带回家。",
        AppFeatures:'应用功能',
        features1:'探索精彩的户外活动和亲子活动',
        features2:'充值 Monkey Coins，兑换精美家庭和儿童礼品',
        features3:'享商家专属优惠，折扣',
        features4:'取得超值现金券',
        downApp:'下载应用',
        newFeatures3:'商家专属优惠',
        newFeatureTitle1:'探索丰富的户外活动与亲子体验',
        newFeatureP1:'精选香港各地一日游学团—海洋公园、迪斯尼乐园、挪亚方舟、巴士厂等等。' +
            '<br>想玩亲子工作坊？体验PizzaExpress披萨制作、雪糕制作等活动。' +
            '<br>立即查看完整行程报名啦。',
        newFeatureTitle2:'充值Monkey Coins换取亲子好礼',
        newFeatureP2:'充值$1,000 / $3,000 / $5,000 / $10,000。可于Monkey Tree及合作品牌兑换限定礼品，或以积分换取各大景点门票—如海洋公园年票、冒险乐园币、JP动感世界门票、Sandbox VR体验等。',
        newFeatureTitle3:'尊享商户独家优惠，立即省更多',
        newFeatureP3:'我们与50+家信誉商户合作。于店内出示App ID或于电商页面输入兑换码，即可享50+项折扣，包括免费儿童餐、升级游玩套票及各类生活型优惠。',
        newFeatureTitle4:'实用现金券，超值折扣好选择',
        newFeatureP4:'在App中即可找到本地日常所需的超值现金券——百佳/惠康/ 759阿信屋/优品360 /美心西饼/ A1 Bakery等热门商户，优惠低至7折起。'
    },
    partners:{
        partnerTitle:'加入我们的大家庭',
        ourPartners:'我们的合作伙伴',
        ourPartnersIntro:'透过与超过 50 家本地及全球旅游和生活方式合作伙伴携手，将您的日常活动转化为精彩奖励和难忘体验，从而提升您的产品服务。',
        partnerIntro:'作为香港首屈一指的亲子奖赏平台合作伙伴，Monkey Tree为您提供一个充满活力的展示舞台，让本地会员轻松发掘多元的儿童活动与亲子生活体验，扩展曝光、吸引家庭客群，一起把更多欢乐带进香港家庭。',
        opportunities:'我们的合作伙伴可享有的几项好处：',
        opportunities1:'接触更多香港客户，拓展实际业务机会',
        opportunities2:'透过多元渠道帮助品牌曝光，提升知名度',
        opportunities3:'获取有价值的数据洞见，优化决策与营销策略',
        opportunities4:'凭借优质客群，实现长远且具永续性的商业成长',
        together:'携手共进，探索新天地…'
    }
}